// extracted by mini-css-extract-plugin
export var askAiIcon = "_q0-9";
export var container = "_q0-0";
export var groupSeparator = "_q0-a";
export var highlight = "_q0-4";
export var resultIcon = "_q0-5";
export var resultItem = "_q0-7";
export var resultSubtitle = "_q0-3";
export var resultTitle = "_q0-2";
export var resultsList = "_q0-1";
export var searchGroup = "_q0-6";
export var selected = "_q0-8";